import { render, staticRenderFns } from "./ReportSummaryCHBACC.vue?vue&type=template&id=2496f092"
import script from "./ReportSummaryCHBACC.vue?vue&type=script&lang=js"
export * from "./ReportSummaryCHBACC.vue?vue&type=script&lang=js"
import style0 from "./ReportSummaryCHBACC.vue?vue&type=style&index=0&id=2496f092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports